import React from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

function Modal({ isOpen, onClose, children, style }) {
  if (!isOpen) return null;

  // 使用createPortal将Modal内容渲染到document.body
  return ReactDOM.createPortal(
    <div className="modal-overlay" style={style}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>&times;</button>
        {children}
      </div>
    </div>,
    document.body
  );
}

export default Modal;